import React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { SimpleModal } from '../../../../../components/simple-modal';
import { messages } from '../../messages';

type PackageConfigAlertModalProps = {
  heading: MessageDescriptor;
  message: MessageDescriptor;
  onConfirm: () => void;
  onCancel: () => void;
};

export const PackageConfigAlertModal = ({ heading, message, onConfirm, onCancel }: PackageConfigAlertModalProps) => (
  <SimpleModal
    actionMessage={messages.confirmButton}
    cancelMessage={messages.cancelButton}
    headerMessage={messages.packageModalAlertTitle}
    onAction={onConfirm}
    onCancel={onCancel}
    onClose={onCancel}
    size='medium'
  >
    <FlexColumn gap={Gap.Space8}>
      <Text textType={TextType.H3} value={heading} />
      <Text textType={TextType.Paragraph} value={message} />
    </FlexColumn>
  </SimpleModal>
);
